import { ReactElement } from "react";
import { Card, CardBody, CardHeader, Heading, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getAreeData } from "../../../store/aree/selectors";
import DoubleColumn from "../../molecules/DoubleColumn";
import useAree from "../../../utils/hooks/useAree";
import AvailableSoon from "../../molecules/AvailableSoon";

const Aree = (): ReactElement => {
  useAree();
  const aree = useSelector(getAreeData);

  return (
    <DoubleColumn>
      {((aree?.length === 0 ?? true) || !aree?.some((area) => area.show)) && (
        <AvailableSoon />
      )}
      {aree?.map((area) => {
        if (area.show) {
          return (
            <Card key={area.id ?? area.title}>
              <CardHeader>
                <Heading size="md">{area.title}</Heading>
              </CardHeader>
              <CardBody>
                {area.guests.map((g) => (
                  <Text>{g}</Text>
                ))}
              </CardBody>
            </Card>
          );
        } else {
          return null;
        }
      })}
    </DoubleColumn>
  );
};

export default Aree;
